<template>
  <div v-if="is_valid_brick" class="d-flex flex-row flex-wrap">
    <div class="flex-w-stretch">
      <b-card class="border-0" no-body>
        <text-fitter
          :value="$t('DIMENSIONS')"
          :font="{ family: 'Bitter', size: 16 }"
          class="py-2 pl-2 border-bottom-primary"
        />
        <text-fitter
          :value="result_dimensions"
          :font="{ family: 'Bitter', size: 32, weight: 'bold' }"
          class="py-4 pl-2 font-weight-bold thumbnail-value"
        />
      </b-card>
    </div>

    <div class="flex-w-stretch">
      <b-card class="border-0" no-body>
        <text-fitter
          :value="$t('SIZE')"
          :font="{ family: 'Bitter', size: 16 }"
          class="py-2 pl-2 border-bottom-success"
        />
        <text-fitter
          :value="result_size"
          :font="{ family: 'Bitter', size: 32, weight: 'bold' }"
          class="py-4 pl-2 font-weight-bold thumbnail-value"
        />
      </b-card>
    </div>

    <div class="flex-w-stretch">
      <b-card class="border-0" no-body>
        <text-fitter
          :value="$t('result_filename')"
          :font="{ family: 'Bitter', size: 16 }"
          class="py-2 pl-2 border-bottom-warning"
        />
        <text-fitter
          :value="result_filename"
          :font="{ family: 'Bitter', size: 32, weight: 'bold' }"
          class="py-4 pl-2 font-weight-bold thumbnail-value"
        />
      </b-card>
    </div>

    <div class="flex-w-stretch">
      <b-card class="border-0" no-body>
        <text-fitter
          :value="$t('creation_date')"
          :font="{ family: 'Bitter', size: 16 }"
          class="py-2 pl-2 border-bottom-danger"
        />
        <text-fitter
          :value="result_creation_date"
          :font="{ family: 'Bitter', size: 32, weight: 'bold' }"
          class="py-4 pl-2 font-weight-bold thumbnail-value"
        />
      </b-card>
    </div>
  </div>
</template>

<i18n>
{
  "en": {
    "DIMENSIONS": "DIMENSIONS",
    "SIZE": "SIZE",
    "result_filename": "Name of result file",
    "creation_date": "Creation date"
  },
  "fr": {
    "DIMENSIONS": "DIMENSIONS",
    "SIZE": "TAILLE",
    "result_filename": "Nom du fichier résultat",
    "creation_date": "Date de création"
  }
}
</i18n>

<script>
import _ from 'lodash'
import moment from 'moment-timezone'
import numeral from 'numeral'

import {
  get_columnstore_general_metadata,
  get_results_file_size,
} from '@/api/subscriptions.js'

import {
  brick_mixin,
  subscription_mixin,
  summary_mixin,
} from '@/components/mixin.js'
import TextFitter from './text_fitter.vue'

// *****************************************************************************

export default {
  name: 'SummaryResult',
  components: { TextFitter },
  mixins: [brick_mixin, subscription_mixin, summary_mixin],
  props: ['project_id', 'brick_id', 'current_metavariables_dict_poid'],
  data() {
    return {
      nb_rows: undefined,
      nb_columns: undefined,
      result_file_size: undefined,
      result_file_last_modification_date: undefined,
    }
  },
  computed: {
    result_creation_date() {
      // TODO : For now, we return the last modification date
      // but it seems to always
      // be the current time : don't know why + decalage horaire
      let res = moment
        .tz(this.result_file_last_modification_date, 'Europe/Paris')
        .format('DD/MM/YY HH[:]mm')
      return res
    },
    result_size() {
      let res = numeral(this.result_file_size).format('0.00b')
      return res
    },
    result_dimensions() {
      let res = this.$t('currently_computing')
      if (!_.isUndefined(this.nb_rows) && !_.isUndefined(this.nb_columns)) {
        res = this.nb_rows + 'L x ' + this.nb_columns + 'C'
      }
      return res
    },
    result_filename() {
      let res = this.cur_brick.filename
      return res
    },
  },
  watch: {
    poids_instantiated: {
      immediate: true,
      async handler(new_val) {
        if (new_val) {
          // let res = await get_columnstore_general_metadata(
          //   this.project_id,
          //   this.metavariables_dicts_poids[0]
          // )
          let res = await get_columnstore_general_metadata(
            this.project_id,
            this.current_metavariables_dict_poid
          )
          this.nb_columns = (res.pipe_object || {}).nb_cols
          this.nb_rows = (res.pipe_object || {}).nb_rows

          // let second_call = await get_results_file_size(
          //   this.project_id,
          //   this.cur_brick.uid,
          //   this.metavariables_dicts_poids[0]
          // )
          let second_call = await get_results_file_size(
            this.project_id,
            this.cur_brick.uid,
            this.current_metavariables_dict_poid
          )
          this.result_file_size = (second_call.pipe_object || {}).result_size
          this.result_file_last_modification_date = (
            second_call.pipe_object || {}
          ).last_modification_date
        }
      },
    },
  },
}
</script>
